import React, { useEffect, useState } from "react";
import TableWrapper from "../../../../component/TableWrapper";
import { Icons } from "../../../../assets";
import NormalSelect from "../../../../component/NormalSelect";
import classes from "../../style.module.scss";
import { useNavigate } from "react-router-dom";
import Button from "../../../../component/Button";
import ConfirmationModal from "../../../../modalComponents/ConfirmationModal";
import Exported from "../../../../service/endpoints";
import request from "../../../../service";
import { Toast } from "../../../../service/toast";
import moment from "moment";

const RetailerList = (props) => {
  const { active, value } =
    props;
  const ACTIVE = "Active";
  const IN_ACTIVE = "Inactive";
  const dropdownList = [
    { label: ACTIVE, value: [ACTIVE] },
    { label: IN_ACTIVE, value: [IN_ACTIVE] },
  ];
  const activeTab = active
  const [params, setParams] = useState()
  const [showConfirmPopUp, setShowConfirmPopUp] = useState(false)
  const [page, setPage] = useState(1);
  const [sortConfig, setSortConfig] = useState(null);
  const [isLoading, setisLoading] = useState(false);
  
  const [programList, setProgramList] = useState({
    
  });
  const navigate = useNavigate();

  const userHeader = [
    { label: "Report Name" },
    { label: "Date Generated" },
    { label: "Actions" },
  ];

  const searchInput = value

  const getRetailerTODList = async () => {
    setisLoading(true);
    let url = `${Exported.Endpoints.getRetailerList}?status=${activeTab === "Completed Reports" ? 1 : 0}`;
    let paramsObj = {
      page: page,
      limit: 10,
    };

    if (searchInput && searchInput !== "") {
      paramsObj["search"] = searchInput;
    }
    if (sortConfig) {
      paramsObj["sort"] = sortConfig?.key;
      paramsObj["sortOrder"] = sortConfig?.direction;
    }

    await request({
      url: url,
      params: { ...paramsObj },
    })
      .then((res) => {
        if (res?.data?.status) {
          const obj = {
            result: res?.data?.data?.list,
            pageMeta: res?.data?.data?.pageMeta,
          };
          setProgramList(obj);
        }
      })
      .catch((err) => {
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
    setisLoading(false);
  };

  useEffect(() => {
    getRetailerTODList(true)
}, [page, activeTab, searchInput])

  const handleData = (keyValue, defaultValue, className = "") => {
    return (
      <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
    );
  };

  const showConfirm =  (id) =>{
    setShowConfirmPopUp(true)
    setParams(id)
  }

  const handleSuccess = async () =>{
    let url = `${Exported.Endpoints.confirmReport}/${params}`
     let paramsObj = {
      confirmedStatus : true
     }

     await request({
      url :url,
      method : Exported.APIMethods.PATCH,
      data : {...paramsObj},
     }).then((res) =>{
      console.log(res)
       getRetailerTODList()
      setShowConfirmPopUp(false)
     }).catch((err) =>{
      console.log(err)
     })
  }

  const downloadFile = (fileUrl) => {
    const link = document.createElement('a');
    link.href = fileUrl;                                    
    link.download = fileUrl.split("/").pop();  

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleClose = () =>{
    setShowConfirmPopUp(false)
  }

  const redirectTo = (id) => {
    navigate(`?id=${id}`)
}

  return (
    <>
      <div className={`eventWrapper`}>
        <div className={`mt-2 mb-5`}>
          <TableWrapper
            headerDetails={userHeader}
            pageMeta={programList?.pageMeta}
            handlePageChange={setPage}
            listLength={programList?.result || []}
            isLoading={isLoading}
          >
            {programList?.result?.map((item, index) => {
              const {
                reportName = "",
                id = "",
                yearGenerated = "",
                updatedAt = ""
              } = item;
              return (
                <tr key={id}>
                  {handleData(reportName, "-", "text-left")}
                  {handleData(moment(updatedAt).format('DD-MM-YYYY'), "-", "text-center")}
                  <td className=" px-3 mx-auto text-center action-button">
                    <div className="flex items-center justify-center">
                    {activeTab === "Completed Reports" ? (
                        item?.confirmedStatus ? (
                          <a onClick={() => downloadFile(item?.uploadedReportUrl)}>
                            <img
                              src={Icons.downloadIcon}
                              alt="Download"
                              className="cursor-pointer w-[18px] h-[16px] mr-2"
                            />
                          </a>
                        ) : (
                          <Button
                            text="Confirm"
                            smallBtn
                            onClick={() => showConfirm(id)}
                          />
                        )
                      ) : (
                        <img
                          src={Icons.eye}
                          alt="View"
                          className="cursor-pointer w-[18px] h-[16px] mr-2"
                          onClick={() => redirectTo(id)}
                        />
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </TableWrapper>
        </div>
      </div>
      {showConfirmPopUp ?
                <ConfirmationModal
                    isOpen={showConfirmPopUp}
                    handleSuccess={handleSuccess}
                    closePopUp={handleClose}
                    warningText={'Confirmation'}
                    modalText={'Confirming the report  lead to sharing the generated data to reflected in respective retailers platform.'}
                    confirmText={'Confirm'}
                    cancelText={'Back'}
                    primaryBtnConfirm={false}
                />
                : null
            }
    </>
  );
};

export default RetailerList;
